import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { OtpSetupComponent } from './otp-setup.component';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormControlComponent, ModalBaseContainerComponent } from '@frogo-kit/core';


@NgModule({
  declarations: [OtpSetupComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    NgOptimizedImage,
    FormControlComponent,
    ModalBaseContainerComponent,
  ],
})
export class OtpSetupModule {}
